import(/* webpackMode: "eager" */ "D:\\Shanta Equity\\app\\layout.jsx");
